import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={18} fill="none" {...props}>
    <path
      fill="#267DFF"
      d="M18.104 10.808c.814 0 1.476-.662 1.476-1.476s-.662-1.475-1.476-1.475H2.364c-.815 0-1.477.661-1.477 1.475 0 .814.662 1.476 1.476 1.476h15.741Zm0-6.887c.814 0 1.476-.662 1.476-1.476 0-.813-.662-1.475-1.476-1.475H2.364C1.548.97.886 1.632.886 2.445c0 .814.662 1.476 1.476 1.476h15.741Zm0 13.774c.814 0 1.476-.662 1.476-1.476s-.662-1.476-1.476-1.476H2.364c-.815 0-1.477.662-1.477 1.476s.662 1.476 1.476 1.476h15.741Z"
    />
  </svg>
);

export default SvgComponent;
